import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=7a054d95"
import script from "./statistics.ts?vue&type=script&lang=src&external"
export * from "./statistics.ts?vue&type=script&lang=src&external"
import style0 from "./statistics.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports